module.exports = "<div class=\"footer\" id=\"footer\">\n  Powered by Vikas Global Solutions Ltd.\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/footer-page/footer-page.component.html
// module id = ./src/app/pages/Main/footer-page/footer-page.component.html
// module chunks = main